import store from '../store';

class MT4Platform {

    constructor() {
        this.user = store.state.user;
    }

    fromExcelToTrades(rawTrades, brokerToLink) {
        let trades = [];
        let excelTrades = [];
        let finish = false;
        let canAdd = false;
        for(let i = 0; i < rawTrades.length && !finish; i++) {
            if (rawTrades[i].length > 0 && rawTrades[i][0] != null) {
                if (rawTrades[i][0].toString().startsWith('Closed Transactions') || rawTrades[i][0].toString().startsWith('Transacciones cerradas'))
                    canAdd = true;
                else if (rawTrades[i][0].toString().startsWith('Open Trades'))
                    finish = true;
                else if (canAdd) {
                    if (rawTrades[i][2] !== 'equilibrar' && rawTrades[i][2] !== 'balance' && rawTrades[i][13] !== 'cancelado' && rawTrades[i][13] !== 'cancelled'
                        && !rawTrades[i][0].toString().startsWith('Closed P/L') && !rawTrades[i][0].toString().startsWith('P / L cerrado') && rawTrades[i][0] !== ' ')
                        excelTrades.push(rawTrades[i]);
                }
            }
        }

        excelTrades.shift();
        excelTrades.forEach((trade) => {
            try {
                let tradeToAdd = {
                    user: {id: this.user.id, login: this.user.username},
                    brokerAccount: {identifier: this.matchIndexes(trade, 'account'), broker: {id: brokerToLink},},
                    assetTicker: this.matchIndexes(trade, 'asset'),
                    side: this.matchIndexes(trade, 'side'),
                    openTime: this.convertDate(this.matchIndexes(trade, 'openTime')),
                    closeTime: this.convertDate(this.matchIndexes(trade, 'closeTime')),
                    openPrice: Number(this.removeCurrency(this.matchIndexes(trade, 'openPrice'))),
                    closePrice: Number(this.removeCurrency(this.matchIndexes(trade, 'closePrice'))),
                    netProfit: Number(this.removeCurrency(this.matchIndexes(trade, 'grossProfit'))),
                    commissions: Number(this.removeCurrency(this.matchIndexes(trade, 'commissions'))),
                    pipValue: 0,
                    stopLossPrice: Number(this.removeCurrency(this.matchIndexes(trade, 'stopLossPrice'))),
                    swap: Number(this.removeCurrency(this.matchIndexes(trade, 'swap'))),
                };

                let priceDistance = Math.abs(tradeToAdd.openPrice - tradeToAdd.closePrice);
                tradeToAdd.pipValue = (priceDistance > 0.0) ? (Math.abs(tradeToAdd.netProfit) / (priceDistance)).toFixed(2) : 0;
                tradeToAdd.netProfit = tradeToAdd.netProfit - Math.abs(tradeToAdd.commissions);
                if (tradeToAdd.stopLossPrice === 0)
                    tradeToAdd.stopLossPrice = (tradeToAdd.side === 'BUY') ? tradeToAdd.openPrice - priceDistance : tradeToAdd.openPrice + priceDistance;
                trades.push(tradeToAdd);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log("There's an error");
            }
        });

        return trades;
    }

    matchIndexes(trade, itemType) {
        switch (itemType) {
            case 'sequence':
                return trade[0];
            case 'account':
                return 'MT4';
            case 'asset':
                return trade[4].toUpperCase();
            case 'side':
                return (trade[2] === 'vender')? 'SELL' : (trade[2] === 'comprar')? 'BUY' : trade[2].toUpperCase();
            case 'openTime':
                return trade[1];
            case 'closeTime':
                return trade[8];
            case 'openPrice':
                return trade[5];
            case 'closePrice':
                return trade[9];
            case 'stopLossPrice':
                return (trade[6] !== undefined && trade[6] != null)? trade[6] : 0;
            case 'swap':
                return trade[12];
            case 'grossProfit':
                return trade[13];
            case 'commissions':
                return trade[10];
        }
    }

    convertDate(stringDate) {
        let array = stringDate.split(' ');
        // Date related
        let date = array[0].split('.');
        let year = date[0];
        let month = date[1];
        let day = date[2];

        // Time related
        let time = array[1].split(':');
        let hour = time[0];
        let minute = time[1];
        return new Date(year, month - 1, day, hour, minute);
    }
    removeCurrency(string) {
        let newString = string.toString();
        let currencies = ['$', '€', '£', '¥', '₽', '₺', 'CHF', 'R', 'S', '₩', '₫', ' '];
        currencies.forEach((currency) => { newString = newString.replace(currency, '') });
        newString = newString.replace(',', '.');
        return newString;
    }
}

export default new MT4Platform();
